import { render, staticRenderFns } from "./AdminDashboardView.vue?vue&type=template&id=6bca11b7"
import script from "./AdminDashboardView.vue?vue&type=script&lang=ts"
export * from "./AdminDashboardView.vue?vue&type=script&lang=ts"
import style0 from "./AdminDashboardView.vue?vue&type=style&index=0&id=6bca11b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports